import "./IconDiv.css";
import { RiUserAddFill } from 'react-icons/ri';
import { AiFillDelete, AiFillCopy, AiOutlineClose } from 'react-icons/ai';
import {BiSolidSearchAlt2} from 'react-icons/bi';
import { BsFillPersonCheckFill } from 'react-icons/bs';


export default (props) => {
    const icon = props.icon;
    const text = props.text;
    const pStyle = props.pStyle;
    const pIcon = props.pIcon;
    const myClassName = props.className || 'icon-1';
    const onClick = props.onClick;
    let cicon, ctext;

    switch (icon) {
        case 'add':
            cicon = <RiUserAddFill className={ myClassName } style={{pIcon}} />
            ctext = text || 'חדש';
            break
        case 'delete':
            cicon = <AiFillDelete  className={ myClassName } style={{pIcon}} />
            ctext = text || 'מחק';
            break
        case 'copy':
            cicon = <AiFillCopy  className={ myClassName } style={{pIcon}} />
            ctext= text || 'העתק';
            break
        case 'search':
            cicon = <BiSolidSearchAlt2 className= {myClassName} style={{pIcon}} />
            ctext = text || 'חפש';
            break
        case 'V':
            cicon = <BsFillPersonCheckFill className= {myClassName} style={{pIcon}} />
            ctext= text || 'הוסף';
            break
        case 'close':
            cicon = <AiOutlineClose className= {myClassName} style={{...pIcon}} />
            ctext= text || 'סגור';
    }

    return (
        <div className="IconDiv" onClick={onClick}>
            {cicon}
            <p style={{...pStyle}} className="IconDivP"> {ctext} </p>
        </div>
    )
}